export const types = {
    SAVE_EMAIL: 'SAVE_EMAIL',
    SAVE_EMAIL_SUCCESS: 'SAVE_EMAIL_SUCCESS',
    SAVE_EMAIL_FAIL: 'SAVE_EMAIL_FAIL',
};
